import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DynamicTable from "./New/DynamicTable";
import { toInventoryHeaders } from "../../utils/inactiveInventoryTable";
import "./InactiveInventoryTable.css";

export default function InactiveInventoryTable({
  headers = [],
  data = [],
  loading = false,
  emptyMessage,
  searchPlaceholder,
  itemLabel = "items",
  minWidth = 940,
}) {
  const { t } = useTranslation();
  const inventoryHeaders = useMemo(() => toInventoryHeaders(headers), [headers]);

  return (
    <div className="inactive-inventory-table">
      <DynamicTable
        title=""
        headers={inventoryHeaders}
        data={data}
        actions={[]}
        loading={loading}
        emptyMessage={emptyMessage || t("noDataFound")}
        searchPlaceholder={searchPlaceholder || t("search")}
        headerVariant="light"
        minWidth={minWidth}
        pagination={{
          enabled: true,
          pageSize: 10,
          itemLabel,
        }}
      />
    </div>
  );
}
